import PubSub from 'pubsub-js';
import { PageEvents } from './page';
import { TextColorCheck } from '../utils/textColorCheck';

import './mostra.scss';

const COMPONENT_NAME = 'mostra';
const BEM = {
  BLOCK: COMPONENT_NAME,
};

/**
 * version    1.0
 * class      <type> (Mostra)
 */
export class Mostra {
  constructor() {
    const self = this;

    this._els = {
      mostra: $(`.${BEM.BLOCK}`),
    };

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      self._els.mostra.each(function () {
        const $instanceEl = $(this);
        TextColorCheck._checkBackground($instanceEl);
      });
    });
  }
}
